import React from 'react';

import ScheduledTransactionEditFormContent from './ScheduledTransactionEditFormContent';
import ScheduledTransactionEditSurface from './ScheduledTransactionEditSurface';
import type { ScheduledTransactionEditViewModel } from './ScheduledTransactionEditViewModel';

type Props = {
  viewModel: ScheduledTransactionEditViewModel;
};

export default function ScheduledTransactionEditView({ viewModel }: Props): React.JSX.Element {
  const {
    actions: { onClose, onCloseClean },
    derived: { open, showAssignSplits, showBackButton, surfaceMode, title },
    navigation: { onBack },
  } = viewModel;

  return (
    <ScheduledTransactionEditSurface
      surfaceMode={surfaceMode}
      onBack={onBack}
      onClose={onClose}
      onCloseClean={onCloseClean}
      open={open}
      showAssignSplits={showAssignSplits}
      showBackButton={showBackButton}
      title={title}
    >
      <ScheduledTransactionEditFormContent viewModel={viewModel} />
    </ScheduledTransactionEditSurface>
  );
}
